import { Controller } from '@hotwired/stimulus';
import { ShadeSwatchController } from '@elc-online/edl-components/js/shade_swatch';

export default class extends Controller {
  static readonly targets = ['container', 'colors'];

  declare colorsTarget: HTMLElement;
  declare containerTarget: HTMLElement;

  initialize(): void {
    new ShadeSwatchController(
      {
        colors: this.colorsTarget,
        container: this.containerTarget,
      },
      {
        mode: 'auto',
      },
    );
  }
}
